module.exports = __webpack_public_path__ + "static/media/use_esim_jpn4.3dc0d21e.png";